import React from 'react'
import styled from 'styled-components'
import { ThemeConsumer } from 'contexts/theme-context'
import { BrowserConsumer } from 'contexts/browser-context'
import { media } from 'tools/browser'
import { Link } from 'atoms'
import { ProfileConsumer } from 'contexts/profile-context'
import { ConfigConsumer } from 'contexts/config-context'
import { settings } from 'contexts/settings-context'
import DataErrorBoundary from 'atoms/DataErrorBoundary'
import LoggedInTopper from './LoggedInTopper'
import LoggedOutTopper from './LoggedOutTopper'

const Topper = styled.div``
const ProfileSection = styled.div`
  color: #b2bbbd;
  background: #3e474f;
  border-bottom: 1px solid #e0e0e0;

  ${media.greaterThan.large`
        color: #384047;
        background: #edeef0;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    `}
`

const WalletLinks = styled.div`
  background: #edeef0;
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  color: #384047;

  a {
    flex: 1;
    padding: 16px 0;
    text-align: center;
    border-right: 1px solid #e0e0e0;
  }

  a:last-child {
    border-right: none;
  }
`

function UserProfileTopper(props) {
  return (
    <DataErrorBoundary>
      <BrowserConsumer>
        {(browser) => (
          <ProfileConsumer>
            {(profile) => (
              <Topper isMobile={browser.lessThan.large}>
                <ConfigConsumer>
                  {(config) => {
                    if (config.suppressAuthUI === true) {
                      return null
                    }
                    return (
                      <ProfileSection>
                        {profile.isAuthenticated === true ? <LoggedInTopper /> : <LoggedOutTopper />}
                      </ProfileSection>
                    )
                  }}
                </ConfigConsumer>

                {profile.isAuthenticated === true && (
                  <ThemeConsumer>
                    {(theme) => {
                      const clientId = theme.clientId.toLowerCase()
                      return (
                        <WalletLinks>
                          {/* Do not show the make a payment button for LeagueSafe (we want to encourage users to pay via the league flow, rather than directly depositing) */}
                          {theme.name !== 'leaguesafe' && (
                            <Link href={`${settings.WALLET_URI}/deposit?client=${clientId}`}>Make a Payment</Link>
                          )}
                          <Link href={`${settings.WALLET_URI}/withdraw?client=${clientId}`}>Request a Payout</Link>
                        </WalletLinks>
                      )
                    }}
                  </ThemeConsumer>
                )}
              </Topper>
            )}
          </ProfileConsumer>
        )}
      </BrowserConsumer>
    </DataErrorBoundary>
  )
}

export default UserProfileTopper



// WEBPACK FOOTER //
// ./src/molecules/UserProfile/components/UserProfileTopper.js